import React from 'react';
import PriceListPage from "./pages/PriceListPage/PriceListPage";

const routesArr = [
  {
    index: true,
    element: <PriceListPage/>
  },
  {
    path: '/pricelist',
    element: <PriceListPage/>
  }
];

export default routesArr;
